export const SET_USER_ADMIN_DETAIL = 'SET_USER_ADMIN_DETAIL';
export const SET_GROUP_ADMIN_DETAIL = 'SET_GROUP_ADMIN_DETAIL';
export const CREATE_GROUP = 'CREATE_GROUP';
export const SET_ADMIN_TAB_INDEX = 'SET_ADMIN_TAB_INDEX';
export const SET_CUSTOMER_ADMIN_DETAIL = 'SET_CUSTOMER_ADMIN_DETAIL'
export const NEW_MANUAL_CASE = 'NEW_MANUAL_CASE'
export const ACTIVE_TAB = 'ACTIVE_TAB'
export const GO_TO_TAB = 'GO_TO_TAB'
export const DISABLE_ADMIN_CASEBODY_TABS = 'DISABLE_ADMIN_CASEBODY_TABS'
export const DESTROY_SESSION='DESTROY_SESSION'
export const SAVE_RAF_DETAILS='SAVE_RAF_DETAILS'
export const DELETE_RAF_DETAILS='DELETE_RAF_DETAILS'
export const PACK_NUMBER_NOT_FOUND='PACK_NUMBER_NOT_FOUND'





// WEBPACK FOOTER //
// ./src/components/Admin/actions/actionTypes.js